module.exports = __webpack_public_path__ + "static/media/sound4.cd4bb696.mp3";